import { QqMessageProcessorBase } from "./qq-message-processor.base";
import { QqActionType, RESET_ACTION } from "../qq-action.type";
import { QqStateType } from "../qq-state.type";
import { QqBundleService } from "../../services/qq-bundle.service";
import { vmDecision } from "../../data/vm-decision.data";

export class SystemProcessor extends QqMessageProcessorBase {
  process(action: QqActionType, state: QqStateType): QqStateType {
    switch (action.type) {
      case RESET_ACTION: {
        const bundleService = new QqBundleService(vmDecision());
        const { currentValues, currentOptions, ctrlPos } =
          bundleService.fillDefault(vmDecision());

        const newState = {
          ctrlBundle: {},
          qqBundle: vmDecision(),
          currentValues: currentValues,
          currentOptions: currentOptions,
          ctrlPos: ctrlPos,
        };

        return newState;
      }
      default:
        return state;
    }
  }
}
